import { cn } from '../../lib/cn';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger' | 'link';
export type ButtonSize = 'sm' | 'md' | 'lg';

const base =
  'inline-flex items-center justify-center gap-2 rounded-lg font-bold no-underline transition-colors select-none ' +
  'disabled:cursor-not-allowed disabled:opacity-60 aria-disabled:cursor-not-allowed aria-disabled:opacity-60';

const variants: Record<ButtonVariant, string> = {
  primary: 'bg-primary text-on-primary hover:bg-primary-hover border-2 border-primary hover:border-primary-hover',
  secondary: 'bg-surface text-primary border-2 border-primary hover:bg-primary-soft',
  ghost: 'bg-transparent text-primary border-2 border-transparent hover:bg-primary-soft',
  danger: 'bg-danger text-on-danger border-2 border-danger hover:opacity-90',
  link: 'bg-transparent text-primary underline underline-offset-4 border-0 px-0 hover:text-primary-hover',
};

// All sizes keep a >= 44px target (R-5.7). Base font is 18px so 2.5rem = 45px.
const sizes: Record<ButtonSize, string> = {
  sm: 'min-h-10 px-3 text-sm',
  md: 'min-h-11 px-4 text-base',
  lg: 'min-h-13 px-6 text-lg',
};

export function buttonClasses(
  opts: { variant?: ButtonVariant; size?: ButtonSize; fullWidth?: boolean; className?: string } = {},
): string {
  const variant = opts.variant ?? 'primary';
  return cn(
    base,
    variants[variant],
    variant === 'link' ? 'min-h-11' : sizes[opts.size ?? 'md'],
    opts.fullWidth && 'w-full',
    opts.className,
  );
}
